import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/src/stylus/app.styl';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#607d8b',
    secondary: '#424242',
    accent: '#ffc107',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#ffc107'
    // warning: '#FB8C00'
    // primary: '#482be7',
    // secondary: '#607D8B',
    // accent: '#9652ff',
    // error: '#e93a7d',
    // info: '#2196F3',
    // success: '#25dac5',
    // warning: '#FFC107'
  }
});

Vue.use(VuetifyDialog);
